// extracted by mini-css-extract-plugin
export default {"wrapper":"UploadInput_wrapper__2agZE"};